import React from 'react';
import styled from 'styled-components';

const RangeStyled = styled.input`
  --track-height: 0.6rem;
  --slider-thumb-size: 1.3em;
  --slider-thumb-radius: 50%;
  --slider-thumb-shadow: 0px 0px 0px 0.7em var(--color-gray-500-20);
  border: none;
  height: 4px;
  width: 143px;
  outline: none;
  transition: background 450ms ease-in;
  accent-color: var(--color-gray-500);
  cursor: pointer;
  width: 100%;

  -webkit-appearance: none;
  appearance: none;
  background: transparent;
  cursor: pointer;

  &:focus {
    outline: none;
  }

  &::-webkit-slider-runnable-track,
  &::-moz-range-track {
    height: var(--track-height);
  }
  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    margin-top: 0;

    background-color: var(--color-gray-500);
    height: var(--slider-thumb-size);
    width: var(--slider-thumb-size);
    border-radius: var(--slider-thumb-radius);

    transition: box-shadow 0.3s;
    box-shadow: 0px 0px 0px 0px transparent;

    &:hover {
      box-shadow: var(--slider-thumb-shadow);
    }
  }
  &::-moz-range-thumb {
    border: none;
    border-radius: 0;

    background-color: var(--color-gray-500);
    height: var(--slider-thumb-size);
    width: var(--slider-thumb-size);
    border-radius: var(--slider-thumb-radius);

    transition: box-shadow 0.3s;
    box-shadow: 0px 0px 0px 0px transparent;

    &:hover {
      box-shadow: var(--slider-thumb-shadow);
    }
  }
`;
const Range = ({
  value,
  onChange,
  onMouseUp,
  min = 0,
  max = 100,
  step = 1,
}: {
  value: number;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onMouseUp?: (event: React.MouseEvent<HTMLInputElement, MouseEvent>) => void;
  min?: number;
  max?: number;
  step?: number;
}) => {
  return (
    <RangeStyled
      className="scaleImage__range"
      type="range"
      min={min}
      max={max}
      step={step}
      style={{
        background: `linear-gradient(to right, var(--color-gray-500) 0%, var(--color-gray-500) ${value}%,#f7f7f7 ${value}%, #f7f7f7 100%)`,
        borderRadius: '5px',
      }}
      value={value}
      onChange={onChange}
      onMouseUp={onMouseUp}
    />
  );
};

export default Range;
